import React from 'react';
import styled from 'styled-components';
import { CheckIcon, colorVars, sizeVars } from '@routific/hive/v5';

interface ScannedPackageCheckboxProps {
  uuid: string;
}

const CheckboxContainer = styled.div`
  border: ${sizeVars.stroke.hairline} solid ${colorVars.border.success.default};
  border-radius: ${sizeVars.space[50]};
  padding: ${sizeVars.space[25]};
  width: ${sizeVars.space[200]};
  height: ${sizeVars.space[200]};
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colorVars.surface.success.mark.default};
  color: ${colorVars.foreground.success.onMark};
`;

const ScannedPackageCheckbox: React.FC<ScannedPackageCheckboxProps> = ({ uuid }) => {
  return (
    <CheckboxContainer data-testid={`scanned-package-checkbox-${uuid}`}>
      <CheckIcon size="sm" />
    </CheckboxContainer>
  );
};

export default ScannedPackageCheckbox;
